import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import reactotron from '../ReactotronConfig'
import mainReducer from './reducers'
import { AppStore } from './types'
import { isDefined } from '../utils/typeGuards'

const middlewares = [applyMiddleware(thunk), reactotron?.createEnhancer()].filter(isDefined)

const store: AppStore = createStore(mainReducer, undefined, compose(...middlewares))

export default store
